module.exports = __webpack_public_path__ + "img/696-c83ff1.png";